import { createSlice } from 'utils/@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit';

import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { layoutSaga } from './saga';
import { LayoutState, ErrorResponse, Profile } from './types';

export const initialState: LayoutState = {
  collapsed: false,
  error: null,
  loading: false,
  openKeys: [],
  profile: undefined,
};

const slice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    toggleCollapse(state) {
      state.collapsed = !state.collapsed;
    },
    setError(state, action: PayloadAction<ErrorResponse | null>) {
      state.error = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setOpenKeys(state, action: PayloadAction<string[]>) {
      state.openKeys = action.payload;
    },
    setProfile(state, action: PayloadAction<Profile>) {
      state.profile = action.payload;
    },
    getProfileInfo(state, action: PayloadAction) {},
    refreshToken(state) {},
  },
});

export const { actions: layoutActions, reducer } = slice;

export const useLayoutSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: layoutSaga });
  return { actions: slice.actions };
};
